/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Epicratingdescription3Inputs */

const id_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diambil dari pemain di ekosistem Epic Games`)
};

const ms_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditangkap daripada pemain dalam ekosistem Epic Games`)
};

const da_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indsamlet fra spillere i Epic Games økosystemet`)
};

const de_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfasst von Spielern im Epic Games-Ökosystem`)
};

const en_us2_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Captured from players in the Epic Games ecosystem`)
};

const es_es2_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capturada de jugadores en el ecosistema de Epic Games`)
};

const es_mx2_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capturada de jugadores en el ecosistema de Epic Games`)
};

const fil_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakuha mula sa mga manlalaro sa Epic Games ecosystem`)
};

const fr_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collectée auprès des joueurs dans l'écosystème Epic Games`)
};

const it_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catturata dai giocatori nell'ecosistema Epic Games`)
};

const hu_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Epic Games ökoszisztéma játékosaitól gyűjtve`)
};

const nl_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastgelegd van spelers in het Epic Games-ecosysteem`)
};

const no_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlet fra spillere i Epic Games-økosystemet`)
};

const pl_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zebrane od graczy w ekosystemie Epic Games`)
};

const pt_br2_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capturado de jogadores no ecossistema da Epic Games`)
};

const pt_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capturado de jogadores no ecossistema Epic Games`)
};

const ro_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capturat de la jucători în ecosistemul Epic Games`)
};

const fi_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerätty pelaajilta Epic Games -ekosysteemissä`)
};

const sv_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insamlat från spelare i Epic Games ekosystem`)
};

const vi_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được thu thập từ người chơi trong hệ sinh thái Epic Games`)
};

const tr_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games ekosistemindeki oyunculardan alınmıştır`)
};

const cs_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zachyceno od hráčů v ekosystému Epic Games`)
};

const bg_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заловена от играчи в екосистемата на Epic Games`)
};

const ru_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получено от игроков в экосистеме Epic Games`)
};

const uk_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримано від гравців в екосистемі Epic Games`)
};

const ar_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مأخوذ من اللاعبين في نظام Epic Games البيئي`)
};

const hi_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games पारिस्थितिकी तंत्र के खिलाड़ियों से कैप्चर किया गया`)
};

const th_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รวบรวมจากผู้เล่นในระบบนิเวศของ Epic Games`)
};

const ja_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games エコシステムのプレイヤーから取得`)
};

const zh_cn2_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来自Epic游戏生态系统内玩家的评分`)
};

const zh_hant1_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`來自Epic遊戲生態系統內玩家的評分`)
};

const ko_offerdetail_overview_epicratingdescription3 = /** @type {(inputs: Offerdetail_Overview_Epicratingdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games 생태계의 플레이어로부터 수집`)
};

/**
* | output |
* | --- |
* | "Captured from players in the Epic Games ecosystem" |
*
* @param {Offerdetail_Overview_Epicratingdescription3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_epicratingdescription3 = /** @type {((inputs?: Offerdetail_Overview_Epicratingdescription3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Epicratingdescription3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "ms") return ms_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "da") return da_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "de") return de_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "fil") return fil_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "fr") return fr_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "it") return it_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "hu") return hu_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "nl") return nl_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "no") return no_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "pl") return pl_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "pt") return pt_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "ro") return ro_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "fi") return fi_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "sv") return sv_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "vi") return vi_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "tr") return tr_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "cs") return cs_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "bg") return bg_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "ru") return ru_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "uk") return uk_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "ar") return ar_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "hi") return hi_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "th") return th_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "ja") return ja_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_epicratingdescription3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_epicratingdescription3(inputs)
	return ko_offerdetail_overview_epicratingdescription3(inputs)
});
export { offerdetail_overview_epicratingdescription3 as "offerDetail.overview.epicRatingDescription" }